export default [
    /* { 
        path: '/', 
        beforeEnter: (to, from, next) => {
            typeof store.state.idActionsRol.find(e => e === 'ACCESO_WEB_ADMIN') != "undefined"
                ? router.push('/admin_ordenes')
                : router.push('/ordenes')
        }
    }, */
    { 
        path: '/', 
        component: () => import('../components/public/wep_page/home/IndexComponent')
    },
    { 
        path: '/nosotros', 
        component: () => import('../components/public/wep_page/about_us/IndexComponent')
    },
    {
        path: '/medicamentos-especialidad/:search?', 
        component: () => import('../components/public/wep_page/services/DrugCatalogsComponent'),
        children:[
            {
                path:'cotizacion',
                component:()=> import('../components/public/wep_page/services/ProdcutsCheckoutComponent')
            },
            {
                path:'producto/:producId',
                component:()=> import('../components/public/wep_page/services/InternalProductComponent')
            }
        ]
    },
    {
        path: '/aplicaciones',
        component:() => import('../components/public/wep_page/services/AplicationsComponent')
    },
    {
        path: '/estudios-medicos',
        component:() => import('../components/public/wep_page/services/MedicalStudiesComponent')
    },
    {
        path: '/enfermeria',
        component:() => import('../components/public/wep_page/services/NursingComponent')
    },
    {
        path: '/empresas_pymes',
        component:() => import('../components/public/wep_page/services/CompaniesAndPymesComponent'),
        children:[
            {
                path: 'cotizacion/:tipo?',
                component:() => import('../components/public/wep_page/services/FormCotizacionComponent')
            }
        ]
    },
    /* { 
        path: '/servicios', 
        component: () => import('../components/public/wep_page/services/IndexComponent'),
        children:[
            {
                path: 'pacientes',
                component:() => import('../components/public/wep_page/services/PatientsComponent'),
                children:[
                    {
                        path: 'medicamentos-especialidad',
                        component:() => import('../components/public/wep_page/services/DrugCatalogsComponent'),
                        children:[
                            {
                                path:'cotizacion',
                                component:()=> import('../components/public/wep_page/services/ProdcutsCheckoutComponent')
                            },
                            {
                                path:'producto/:producId',
                                component:()=> import('../components/public/wep_page/services/InternalProductComponent')
                            }
                        ]
                    },
                    {
                        path: 'aplicaciones',
                        component:() => import('../components/public/wep_page/services/AplicationsComponent')
                    },
                    {
                        path: 'enfermeria',
                        component:() => import('../components/public/wep_page/services/NursingComponent')
                    }
                ]
            },
            {
                path: 'empresas_pymes',
                component:() => import('../components/public/wep_page/services/CompaniesAndPymesComponent'),
                children:[
                    {
                        path: 'cotizacion/:tipo?',
                        component:() => import('../components/public/wep_page/services/FormCotizacionComponent')
                    }
                ]
            },
            {
                path: 'analisis-laboratorio',
                component:() => import('../components/public/wep_page/services/LaboratoryAnalysis')
            },
            {
                path: 'estudios-medicos',
                component:() => import('../components/public/wep_page/services/MedicalStudiesComponent')
            }
        ]
    }, */
    { 
        path: '/sedes', 
        component: () => import('../components/public/wep_page/head_quarters/IndexComponent'),
        children:[
            {
                path: 'farmacia-quito',
                component:() => import('../components/public/wep_page/head_quarters/PharmacyUioComponent')
            },
            {
                path: 'farmacia-guayaquil',
                component:() => import('../components/public/wep_page/head_quarters/PharmacyGyeComponent')
            },
            {
                path: 'centro-aplicaciones-quito',
                component:() => import('../components/public/wep_page/head_quarters/AplicationsCenterUioComponent')
            },
            /* {
                path: 'laboratorio-quito',
                component:() => import('../components/public/wep_page/head_quarters/LaboratoryUioComponent')
            }, */
            {
                path: 'centro-aplicaciones-guayaquil',
                component:() => import('../components/public/wep_page/head_quarters/AplicationsCenterGyeComponent')
            },
            {
                path: 'laboratorio-guayaquil',
                component:() => import('../components/public/wep_page/head_quarters/LaboratoryGyeComponent')
            }
        ]
    },
    { 
        path: '/admin_ordenes', 
        component: () => import('../components/private/orders/AdminOrdersComponent'),
        meta: { requiresAuth: true },
    },
    { 
        path: '/ordenes',
        component: () => import('../components/public/orders/ListOrdersComponent'),
        meta: { requiresAuth: true },
    },
    { 
        path: '/carga_masiva',
        component: () => import('../components/private/orders/UploadOrdersMassiveComponent'),
        meta: { requiresAuth: true },
    },
    { 
        path: '/campana',
        component: () => import('../components/private/orders/PanelCampaignsComponent'),
        meta: { requiresAuth: true },
    },
    { 
        path: '/login', 
        component: () => import('../components/access/LoginComponent') ,
        meta: { requiresAuth: false },
        beforeEnter: (to, from, next) => {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            next();
        }
    },
    { 
        path: '/recuperar_contrasena', 
        component: () => import('../components/access/RecoverPasswordComponent') ,
        meta: { requiresAuth: false },
        beforeEnter: (to, from, next) => {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            next();
        }
    },
    { 
        path: '/reiniciar_contrasena/:token', 
        component: () => import('../components/access/ResetPasswordComponent') ,
        meta: { requiresAuth: false }
    },
    { 
        path: '/contactos', 
        component: () => import('../components/public/wep_page/contacts/IndexComponent')
    },
    { 
        path: '/trabaja-con-nosotros', 
        component: () => import('../components/public/wep_page/services/WorkWhitUsComponent')
    },
    { 
        path: '/covid19', 
        component: () => import('../components/public/wep_page/services/Covid12Component')
    },
    { 
        path: '/validar-usuario/:token', 
        component: () => import('../components/access/AuthUserComponent') ,
        meta: { requiresAuth: false }
    },

  ]